import { Chip } from '@mui/material'
import { useMinimalsTheme } from '@tom-ui/ui'

export const ContainerJourneyCardChip = ({
  label,
  tooltip,
  maxWidth,
  dataCy,
}: {
  label: React.ReactNode
  tooltip?: string
  maxWidth?: number
  dataCy?: string
}) => {
  const theme = useMinimalsTheme()
  return (
    <Chip
      label={label}
      variant='filled'
      size='small'
      sx={{
        padding: 0,
        borderRadius: '2px',
        fontSize: '12px',
        fontWeight: 600,
        color: theme.palette.grey[600],
      }}
      data-cy={dataCy}
      style={{ maxWidth: maxWidth }}
      title={tooltip}
    />
  )
}
